import { Star, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const experts = [
    {
        initials: "DA",
        name: "Dr. Ananya Reddy",
        specialty: "Additive Manufacturing",
        institution: "IIT Tirupati",
        rating: 4.9,
        price: 1500,
    },
    {
        initials: "PK",
        name: "Prof. Karthik Iyer",
        specialty: "Robotics & Mechatronics",
        institution: "IIIT Sri City",
        rating: 4.8,
        price: 1800,
    },
    {
        initials: "MS",
        name: "Meera Sundaram",
        specialty: "PCB & Embedded Design",
        institution: "APIC Visakhapatnam",
        rating: 4.7,
        price: 1200,
    },
    {
        initials: "RV",
        name: "Rahul Varma",
        specialty: "EV Powertrain",
        institution: "Ashok Leyland R&D",
        rating: 4.9,
        price: 2200,
    },
];

export default function Experts() {
    return (
        <section className="max-w-7xl mx-auto px-6 py-16">
            {/* Header */}
            <div className="flex flex-wrap items-start justify-between gap-4 mb-8">
                <div>
                    {/* <span className="inline-flex items-center text-xs font-semibold border border-gray-200 rounded-full px-4 py-1.5 mb-4">
                        Experts
                    </span> */}

                    <h2 className="text-4xl font-extrabold text-gray-900 mb-2">
                        Consult domain leaders
                    </h2>

                    <p className="text-gray-500 text-lg">
                        260+ vetted experts across additive, robotics, EV, PCB and more.
                    </p>
                </div>

                <Link
                    to="/experts"
                    className="flex items-center gap-2 border border-gray-200 rounded-xl px-5 py-2.5 font-semibold text-gray-900 hover:bg-gray-50 transition whitespace-nowrap"
                >
                    Meet all experts
                    <ArrowRight className="w-4 h-4" />
                </Link>
            </div>

            {/* Expert cards */}
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {experts.map((expert) => (
                    <div
                        key={expert.name}
                        className="bg-white border border-gray-200 rounded-2xl p-6 hover:shadow-lg transition"
                    >
                        <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-white font-bold text-lg mb-5">
                            {expert.initials}
                        </div>

                        <h3 className="font-bold text-gray-900 text-lg mb-1">
                            {expert.name}
                        </h3>
                        <p className="text-gray-500 text-sm leading-snug">
                            {expert.specialty}
                            <br />
                            {expert.institution}
                        </p>

                        <div className="flex items-center justify-between mt-6">
                            <span className="flex items-center gap-1 text-sm font-medium text-gray-900">
                                <Star className="w-4 h-4 fill-orange-400 text-orange-400" />
                                {expert.rating}
                            </span>
                            <span className="text-sm font-semibold text-indigo-600">
                                ₹{expert.price.toLocaleString("en-IN")}/session
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}